import React from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import { useUser } from 'features/auth/store/userStore'

export default function SwitchRoleRoute() {
  const { switchRoleRouter } = useUser()
  return switchRoleRouter ? <Outlet /> : <Navigate to='/' />
}
